import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {
    AiSuggestionStatistics,
    SubmitFeedbackRequest,
    SubmitFeedbackResponse
} from "../../model/dto/api/ai-segment-suggestion.interface";
import {AiSuggestionFeedbackDto} from "../../model/dto/entity/ai-suggestion-feedback.dto";

/**
 * Service for AI suggestion feedback.
 * F-024: AI-Powered Segment Suggestions - User feedback for ML training.
 */
@Injectable({
    providedIn: 'root'
})
export class AiSuggestionFeedbackService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/aiSuggestionFeedback')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-thumbs-up';
    }

    /**
     * Submits feedback for an AI suggestion.
     */
    submitFeedback(request: SubmitFeedbackRequest): Observable<SubmitFeedbackResponse> {
        return this.postGeneric<SubmitFeedbackResponse>(request, '/submit');
    }

    /**
     * Updates existing feedback.
     */
    updateFeedback(feedbackId: number, request: SubmitFeedbackRequest): Observable<AiSuggestionFeedbackDto> {
        return this.http.put<AiSuggestionFeedbackDto>(
            `${MvsCrudService.baseUrl}/ct/aiSuggestionFeedback/${feedbackId}`,
            request
        );
    }

    /**
     * Gets feedback for a suggestion.
     */
    getFeedbackForSuggestion(suggestionId: number): Observable<AiSuggestionFeedbackDto[]> {
        return this.getGeneric<AiSuggestionFeedbackDto[]>(`/suggestion/${suggestionId}`);
    }

    /**
     * Gets feedback submitted by a user.
     */
    getFeedbackByUser(userId: number): Observable<AiSuggestionFeedbackDto[]> {
        return this.getGeneric<AiSuggestionFeedbackDto[]>(`/user/${userId}`);
    }

    /**
     * Gets average rating for a suggestion.
     */
    getAverageRating(suggestionId: number): Observable<number> {
        return this.getGeneric<number>(`/suggestion/${suggestionId}/averageRating`);
    }

    /**
     * Gets overall AI suggestion statistics.
     */
    getStatistics(): Observable<AiSuggestionStatistics> {
        return this.getGeneric<AiSuggestionStatistics>('/statistics');
    }

    /**
     * Gets high-rated feedback for ML training.
     */
    getHighRatedFeedback(minRating: number = 4): Observable<AiSuggestionFeedbackDto[]> {
        return this.getGeneric<AiSuggestionFeedbackDto[]>(`/highRated?minRating=${minRating}`);
    }

    /**
     * Gets feedback where suggestions were applied.
     */
    getAppliedFeedback(): Observable<AiSuggestionFeedbackDto[]> {
        return this.getGeneric<AiSuggestionFeedbackDto[]>('/applied');
    }
}
